var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.field.hidden
    ? _c(
        _setup.FormControlTypeRelationshipManyToMany,
        _vm._g(
          _vm._b(
            {},
            "FormControlTypeRelationshipManyToMany",
            _vm.$props,
            false
          ),
          _vm.$listeners
        )
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }